/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Who_TitleInputs */

const en_mk_abt_who_title = /** @type {(inputs: Mk_Abt_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who builds it`)
};

const id_mk_abt_who_title = /** @type {(inputs: Mk_Abt_Who_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa yang membangunnya`)
};

/**
* | output |
* | --- |
* | "Who builds it" |
*
* @param {Mk_Abt_Who_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_who_title = /** @type {((inputs?: Mk_Abt_Who_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Who_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_who_title(inputs)
	return en_mk_abt_who_title(inputs)
});